export const USER_TYPE_AGENT = 'agent';
export const USER_TYPE_INVESTOR = 'investor';
